import { Avatar as ComponentsAvatar, Icon } from '@genial/components';
import { Color } from '@genial/design-tokens';
import React from 'react';
import { Pressable } from 'react-native';
import { useRecoilValue } from 'recoil';

import { masterState } from '../../../../store/master/atom';
import { sessionState } from '../../../../store/session/atom';

export namespace AvatarTypes {
  export interface Props {
    onPress?: () => void;
  }
}

export const Avatar: React.FC<AvatarTypes.Props> = ({ onPress }) => {
  const { userProfile } = useRecoilValue(sessionState);
  const { selectedAdvisor } = useRecoilValue(masterState);

  return (
    <Pressable onPress={onPress}>
      {selectedAdvisor !== undefined ? (
        <Icon
          name="Impersonate"
          color={Color['neutral.white']}
          size="sm"
          variant="rounded"
          padding={0}
          backgroundColor={Color['brand.tertiary.darkest']}
        />
      ) : (
        <ComponentsAvatar
          initials={userProfile?.initials}
          bgColor="brand.tertiary.principal"
          textColor="neutral.white"
          testId="avatar"
        />
      )}
    </Pressable>
  );
};
